export default "__VITE_ASSET__BD02$FD2__"